import script from "./entryNewNav.vue?vue&type=script&lang=ts&setup=true"
export * from "./entryNewNav.vue?vue&type=script&lang=ts&setup=true"

import "./entryNewNav.vue?vue&type=style&index=0&id=1dc1ff0c&lang=less&scoped=true"
import "./entryNewNav.vue?vue&type=style&index=1&id=1dc1ff0c&lang=less"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dc1ff0c"]])

export default __exports__